// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => ({"121":"vendor","792":"main","869":"styles"}[chunkId] + ".css");